import axios from '@/axios.js'

export default {
  fetchDataListItems ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/product/data')
        .then((response) => {
          commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/product/update', {item})
        .then((response) => {
          commit('UPDATE_PRODUCTS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/product/create', {item})
        .then((response) => {
          commit('CREATE_PRODUCTS', Object.assign(response.data.data, {id: response.data.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
